// Demo presets for the Ontario Progress Report Card - Grades 7-8 (pgrc7to8_2023_07).
// Each preset is a complete flat object matching every key in formSchema.
// Plan values: "ESLELD" | "IEP" | "NA" | "Core" | "Immersion" | "Extended" | "French" | ""
// Result values: "PWD" | "PW" | "PVW" | ""
// Learning skill values: "E" | "G" | "S" | "N" | ""

export const PRESETS = [
  {
    label: 'Example: Priya Sharma',
    data: {
      date: '2024-11-15',
      studentName: 'Priya Sharma',
      oen: '234567890',
      grade: '7',
      teacher: 'Ms. Nguyen',
      board: 'Toronto District School Board',
      school: 'Greenwood Junior High',
      address1: '200 Elm Street',
      address2: 'Toronto, ON M5T 1A2',
      principal: 'Ms. Rivera',
      telephone: '416-555-0200',
      boardInformation1: '',
      daysAbsent: '1',
      totalDaysAbsent: '3',
      timesLate: '0',
      totalTimesLate: '0',
      responsibility: 'E',
      organization: 'G',
      independentWork: 'G',
      collaboration: 'E',
      initiative: 'G',
      selfRegulation: 'E',
      strengthsNextStepsLSWH:
        'Priya demonstrates excellent responsibility and self-regulation. Next steps: continue to build initiative when approaching new and challenging tasks.',
      languagePlan: '',
      languageResult: 'PVW',
      frenchPlan: 'Core',
      frenchResult: 'PW',
      nativeLanguage: '',
      nativeLanguagePlan: '',
      nativeLanguageResult: '',
      mathematicsPlan: '',
      mathematicsResult: 'PW',
      scienceAndTechnologyPlan: '',
      scienceAndTechnologyResult: 'PVW',
      historyPlan: '',
      historyResult: 'PW',
      geographyPlan: '',
      geographyResult: 'PW',
      healthEducationPlan: '',
      healthEducationResult: 'PW',
      physicalEducationPlan: '',
      physicalEducationResult: 'PVW',
      artsHeader: 'The Arts',
      arts1: 'Visual Arts',
      arts1Plan: '',
      arts1Result: 'PVW',
      arts2: 'Music',
      arts2Plan: '',
      arts2Result: 'PW',
      arts3: 'Drama',
      arts3Plan: '',
      arts3Result: 'PW',
      arts4: 'Dance',
      arts4Plan: '',
      arts4Result: 'PW',
      optionalStudies: '',
      optionalStudiesPlan: '',
      optionalStudiesResult: '',
      strengthsNextStepsSubjects:
        'Priya excels in Science & Technology and Language. Next steps: deepen analytical writing skills in History and Geography.',
      boardInformation2: '',
    },
  },
  {
    label: 'Example: Marcus Thompson',
    data: {
      date: '2024-11-15',
      studentName: 'Marcus Thompson',
      oen: '345678901',
      grade: '8',
      teacher: 'Mr. Okonkwo',
      board: 'Toronto District School Board',
      school: 'Greenwood Junior High',
      address1: '200 Elm Street',
      address2: 'Toronto, ON M5T 1A2',
      principal: 'Ms. Rivera',
      telephone: '416-555-0200',
      boardInformation1: '',
      daysAbsent: '5',
      totalDaysAbsent: '8',
      timesLate: '2',
      totalTimesLate: '3',
      responsibility: 'G',
      organization: 'S',
      independentWork: 'G',
      collaboration: 'G',
      initiative: 'G',
      selfRegulation: 'S',
      strengthsNextStepsLSWH:
        'Marcus works well in collaborative settings and demonstrates good initiative. Next steps: develop stronger organizational habits for multi-step assignments.',
      languagePlan: 'IEP',
      languageResult: 'PWD',
      frenchPlan: 'Core',
      frenchResult: 'PW',
      nativeLanguage: '',
      nativeLanguagePlan: '',
      nativeLanguageResult: '',
      mathematicsPlan: 'IEP',
      mathematicsResult: 'PW',
      scienceAndTechnologyPlan: '',
      scienceAndTechnologyResult: 'PW',
      historyPlan: '',
      historyResult: 'PW',
      geographyPlan: '',
      geographyResult: 'PW',
      healthEducationPlan: '',
      healthEducationResult: 'PVW',
      physicalEducationPlan: '',
      physicalEducationResult: 'PVW',
      artsHeader: 'The Arts',
      arts1: 'Visual Arts',
      arts1Plan: '',
      arts1Result: 'PW',
      arts2: 'Music',
      arts2Plan: '',
      arts2Result: 'PVW',
      arts3: 'Drama',
      arts3Plan: '',
      arts3Result: 'PW',
      arts4: '',
      arts4Plan: '',
      arts4Result: '',
      optionalStudies: '',
      optionalStudiesPlan: '',
      optionalStudiesResult: '',
      strengthsNextStepsSubjects:
        'Marcus shows real strength in Health and Physical Education and Music. In Language, he is making steady progress with IEP accommodations. Next steps: focus on written response structure in History.',
      boardInformation2: '',
    },
  },
  {
    label: 'Example: Fatima Al-Hassan',
    data: {
      date: '2024-11-15',
      studentName: 'Fatima Al-Hassan',
      oen: '456789012',
      grade: '7',
      teacher: 'Ms. Nguyen',
      board: 'Toronto District School Board',
      school: 'Greenwood Junior High',
      address1: '200 Elm Street',
      address2: 'Toronto, ON M5T 1A2',
      principal: 'Ms. Rivera',
      telephone: '416-555-0200',
      boardInformation1: '',
      daysAbsent: '2',
      totalDaysAbsent: '2',
      timesLate: '0',
      totalTimesLate: '0',
      responsibility: 'G',
      organization: 'G',
      independentWork: 'G',
      collaboration: 'G',
      initiative: 'G',
      selfRegulation: 'G',
      strengthsNextStepsLSWH:
        'Fatima is a conscientious and engaged learner. Next steps: take more intellectual risks and share ideas during class discussions.',
      languagePlan: 'ESLELD',
      languageResult: 'PW',
      frenchPlan: 'Core',
      frenchResult: 'PW',
      nativeLanguage: 'Arabic',
      nativeLanguagePlan: '',
      nativeLanguageResult: 'PW',
      mathematicsPlan: '',
      mathematicsResult: 'PVW',
      scienceAndTechnologyPlan: '',
      scienceAndTechnologyResult: 'PW',
      historyPlan: '',
      historyResult: 'PW',
      geographyPlan: '',
      geographyResult: 'PW',
      healthEducationPlan: '',
      healthEducationResult: 'PW',
      physicalEducationPlan: '',
      physicalEducationResult: 'PW',
      artsHeader: 'The Arts',
      arts1: 'Visual Arts',
      arts1Plan: '',
      arts1Result: 'PW',
      arts2: 'Music',
      arts2Plan: '',
      arts2Result: 'PW',
      arts3: '',
      arts3Plan: '',
      arts3Result: '',
      arts4: '',
      arts4Plan: '',
      arts4Result: '',
      optionalStudies: 'Islamic Studies',
      optionalStudiesPlan: '',
      optionalStudiesResult: 'PW',
      strengthsNextStepsSubjects:
        'Fatima demonstrates strong mathematical ability and steady growth across all subjects. Next steps: deepen comprehension strategies in Language to support continued ESL/ELD progress.',
      boardInformation2: '',
    },
  },
];
